var map = {
	"./black/shipinhuiyi.png": "aV07",
	"./blue/shipinhuiyi.png": "KcCt",
	"./white/shipinhuiyi.png": "HRVf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lalr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/shipinhuiyi\.png$
// module id = Lalr
// module chunks = 24